module.exports = __webpack_public_path__ + "img/pic_shipeichanpin@2x.b9d06c43.png";